export default "__VITE_ASSET__iZ6aGyRo__"